import React from 'react';
import { Points } from 'components/Points/Points';
import './CardGroupHeaderResponsive.css';

interface CardGroupHeaderResponsiveProps {
  title: string;
  lowPrice?: number;
  highPrice?: number;
  totalValue?: number;         // For Send Cards page
  autoMatch?: boolean;         // For Send Cards page
  onAutoMatchToggle?: (val: boolean) => void;
  mode?: 'printings' | 'send'; // Determines which header to render
}

const CardGroupHeaderResponsive: React.FC<CardGroupHeaderResponsiveProps> = ({
  title,
  lowPrice,
  highPrice,
  totalValue,
  autoMatch = false,
  onAutoMatchToggle,
  mode = 'printings',
}) => {
  return (
    <div className="card-group-header-responsive">
      {/* Mobile: Hide title on mobile since it's shown in user info bar */}
      <span className="header-title-responsive header-title-desktop-only">{title}</span>

      {mode === 'printings' && (
        <div className="header-prices-responsive">
          <div className="price-item-responsive">
            <span className="price-label-responsive">Low</span>
            <Points points={lowPrice || 0} type="small" />
          </div>
          <div className="price-item-responsive">
            <span className="price-label-responsive">High</span>
            <Points points={highPrice || 0} type="small" />
          </div>
        </div>
      )}

      {mode === 'send' && (
        <div className="header-prices-responsive">
          {/* Desktop: Show Auto-Match toggle */}
          <div className="price-item-responsive auto-match-container-desktop">
            <span className="price-label-responsive">🚧 Auto-Match</span>
            <label className="auto-match-toggle-desktop">
              <input
                type="checkbox"
                checked={autoMatch}
                onChange={(e) => onAutoMatchToggle?.(e.target.checked)}
              />
              <span className="toggle-slider-desktop" />
            </label>
          </div>
          <div className="price-item-responsive">
            <Points points={totalValue || 0} type="small" />
          </div>
        </div>
      )}
    </div>
  );
};

export default CardGroupHeaderResponsive;
